import { get } from 'helpers/api';
import { trackEvent } from '../search/helpers/google_analytics_helpers';

export function fetchDocuments(companyId: string, jurisdictionCode: string) {
  trackEvent('connect_off_market_llc_document_fetch', { companyId, jurisdictionCode });
  return get(
    '/prospect/llc_lookup/documents',
    { params: { companyId: companyId, jurisdictionCode: jurisdictionCode } }
  );
}
